<template>
  <v-dialog
    v-model="toggle_data_liftmaintenance_cables_state"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card color="primary">
        <v-btn icon @click="toggleLiftmaintenanceCablesListView()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Lift Cables</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter lift cable data"
        ></v-text-field>
      </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="computedLiftMaintenanceCablesGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.properties.lift_name }}</td>
            <td>{{ props.item.properties.cable_dir }}
            <td>{{ props.item.properties.manufacturer }}</td>
            <td>{{ props.item.properties.type }}</td>
            <td>{{ props.item.properties.num_twrs }}</td>
            <td>{{ props.item.properties.num_carriers }}</td>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>

        </v-data-table>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        search: '',
        rows_per_page: [
          10, 25, 50,
          { 'text': 'All',
            'value': -1
          }
        ],
        rows_per_page_text: 'Per page:',
        headers: [
          {
            text: 'Lift Name',
            value: 'properties.lift_name'
          },
          {
            text: 'Cable Direction',
            value: 'properties.cable_dir'
          },
          {
            text: 'Manufacturer',
            value: 'properties.manufacturer'
          },
          {
            text: 'Type',
            value: 'properties.type'
          },
          {
            text: '# of Towers',
            value: 'properties.num_twrs'
          },
          {
            text: '# of Carriers',
            value: 'properties.num_carriers'
          }
        ]
      }
    },
    computed: {
      computedLiftMaintenanceCablesGeoJsonFeatures () {
        return this.$store.state.layers.liftmaintenance.mapLayers.cables.geojson.features
      },
      toggle_data_liftmaintenance_cables_state: {
        get: function () {
          return this.$store.state.layers.liftmaintenance.mapLayers.cables.visibility.listView
        },
        set: function () {
          this.toggleLiftmaintenanceCablesListView()
        }
      }
    },
    methods: {
      toggleLiftmaintenanceCablesListView () {
        this.$store.commit('mutationListLayer', {
          dept: 'liftmaintenance',
          layer: 'cables'
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dataLiftmaintenanceCables.vue